<template>
    <span>{{ value }} <span
        class="openBacklogABBWChangesCell"
        :class="getBacklogNetChangesByWorkstreamClass"
    >{{ formattedOpenBacklogChangesByWs }}</span></span>
</template>

<script lang="ts">

export default {
    props: ['params'],
    computed: {
        value() {
            if (this.params.value !== null) {
                return  this.params.value;
            }
            return '';
        },

        // Format to display __NetChange
        formattedOpenBacklogChangesByWs() {
            const rowData = this.params.data; // Access the entire row's data
            const ageBandName = this.params.column.userProvidedColDef.headerName;
            const netChangeFieldName = `${ageBandName}__NetChange`;
            const netChangeOfAgeBandValue = rowData[netChangeFieldName];
            return netChangeOfAgeBandValue ? (netChangeOfAgeBandValue > 0 ? '+' : '') + netChangeOfAgeBandValue : '';
        },
        getBacklogNetChangesByWorkstreamClass() {
            const rowData = this.params.data; // Access the entire row's data
            const ageBandName = this.params.column.userProvidedColDef.headerName;
            const netChangeFieldName = `${ageBandName}__NetChange`;
            const netChangeOfAgeBandValue = rowData[netChangeFieldName];

            if (netChangeOfAgeBandValue > 0) {
                return 'is-pos';
            }
            return 'is-neg';
        }
    }
};
</script>

<style lang="scss">

// Positive mean (backlog is growing) red. negative (backlog is declining) is good
.openBacklogABBWChangesCell.is-pos { color: var(--color-status-negative); }
.openBacklogABBWChangesCell.is-neg { color: var(--color-status-positive); }
.openBacklogABBWChangesCell.is-zero { color: var(--color-status-neutral); }

</style>